/***************/
/**  IMPORTS  **/
/***************/
import React from "react";
import {
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";
import { useEffect, useState } from "react";

/******************/
/**  PDF STYLES  **/
/******************/
const styles = StyleSheet.create({
    rowName: {
        flexDirection: "row",
        display: "flex",
        fontSize: "8px",
        marginLeft: "7px",
        width: "auto",
    },
    columnBuilding: {
        flexDirection: "column",
        display: "flex",
        width: "15px",
        fontSize: "8px",
        marginLeft: "5px",
    },
});

/**
 * This component is responsible for creating a row of locations at a given building
 * @param { JSONObject } data
 * @param { JSONObject } addresses
 * @returns A row locations at a given building
 */
const PdfLocation1 = ({ data, addresses, flipped, highlightAvailableIsChecked, highlightTempClosedIsChecked }) => {

    const [message, setMessage] = useState([]);

    /**  HANDLES OBTAINING ADDRESS'S DATA  **/
    useEffect(() => {
        if(flipped){
            if (addresses.evens.length > 0) {
                const locations = addresses.evens?.filter(item => item.address.substr(0,4) === data.address.substr(0,4));
                setMessage(locations);
            }
        }else {
            if (addresses.odds.length > 0) {
                const locations = addresses.odds?.filter(item => item.address.substr(0,4) === data.address.substr(0,4));
                setMessage(locations);
            }
        }
        
    }, [addresses.odds]);

    const truncateText = (text, maxChars = 32) => {
        return text.length > maxChars ? text.slice(0, maxChars - 3) + '...' : text;
    };
    
    if(message.length > 0) {
        return (
            <View style={{flexDirection: 'row', display: 'flex' }}>
                { message.length > 0 ? (
                    <>
                    <View style={styles.columnBuilding}>
                        <Text>{message[0].address.split(' ')[0]}</Text>
                    </View>
                    <View style={{flexDirection: "column", display: 'flex'}}>
                        {message.map(((item) => {
                            return (
                                <View 
                                    style={[styles.rowName, {backgroundColor: (highlightAvailableIsChecked && item.businessName.includes("Space Available")) || (highlightTempClosedIsChecked && item.businessName.includes("Temp. Closed")) ? "yellow" : "white"}]}
                                    key={item._id}>
                                    <Text>{truncateText(item.businessName)}</Text>
                                </View>
                            )
                        }))}
                    </View>
                </>
                ) : (
                    <View style={{flexDirection: 'column', display: 'flex'}}></View>
                )}
            </View>
            )
        } else {
            return null
        }
        }

export default PdfLocation1;
